import { useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AboutPreview from './components/AboutPreview';
import GallerySection from './components/GallerySection';
import AreasSection from './components/AreasSection';
import ReviewsSection from './components/ReviewsSection';
import QuoteForm from './components/QuoteForm';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import TrustSignals from './components/TrustSignals';
import { useSEO, generateLocalBusinessSchema, generateFAQSchema } from '../../utils/seo';

const FAQ_ITEMS = [
  {
    question: 'How much do painters and decorators charge in Watford?',
    answer: 'Professional painters and decorators in Watford typically charge between £150–£250 per day depending on project complexity. At Brushour, we provide free, no-obligation quotes tailored to your specific needs. Prices vary based on room size, surface preparation required, and paint quality. Contact us for an accurate estimate for your painting project in Watford, Rickmansworth, or surrounding Hertfordshire areas.',
  },
  {
    question: 'How long does it take to paint a house in Watford?',
    answer: 'A typical 3-bedroom house interior in Watford takes 5–7 days to paint professionally, including preparation and drying time. Exterior painting usually takes 3–5 days depending on weather conditions. Brushour\'s experienced decorators work efficiently while maintaining the highest quality standards.',
  },
  {
    question: 'Do you provide free quotes in Watford and Hertfordshire?',
    answer: 'Yes! Brushour provides completely free, no-obligation quotes throughout Watford, Rickmansworth, Chorleywood, Northwood, and all surrounding Hertfordshire areas. We visit your property, assess the work required, discuss your preferences, and provide a detailed written quote. There\'s no pressure to proceed, and our quotes are valid for 30 days.',
  },
  {
    question: 'Are Brushour painters and decorators fully insured?',
    answer: 'Absolutely. Brushour carries full public liability insurance up to £1 million, protecting your Watford property throughout the painting and decorating process. We\'re also fully qualified with 18+ years of experience serving Hertfordshire homeowners and businesses.',
  },
  {
    question: 'What areas around Watford do you cover?',
    answer: 'Brushour proudly serves Watford and all surrounding Hertfordshire areas including Rickmansworth, Chorleywood, Northwood, Pinner, Bushey, Radlett, and Gerrards Cross. We\'re local painters and decorators who understand the specific needs of properties in these areas.',
  },
  {
    question: 'What painting services does Brushour offer in Watford?',
    answer: 'Brushour offers comprehensive painting and decorating services in Watford including interior painting, exterior painting, wallpaper installation and removal, limewash painting, spray painting, colour consultation, and both residential and commercial decorating.',
  },
];

export default function HomePage() {
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Watford Painters & Decorators | Brushour Hertfordshire',
    description: 'Brushour are professional painters and decorators in Watford, Hertfordshire with 18+ years of experience. Interior & exterior painting, wallpaper installation, and commercial decorating. Free quotes across Hertfordshire.',
    keywords: 'painters decorators Watford, painting decorating Hertfordshire, interior painting Watford, exterior painting Hertfordshire, wallpaper installation Watford, Brushour',
    canonical: `${SITE_URL}/`,
    ogImage: 'https://static.readdy.ai/image/3d769dc1e01059223eb26668720a1761/e6c157647967ffb5fa62a9e4cb4fe039.png',
    schema: [generateLocalBusinessSchema(), generateFAQSchema(FAQ_ITEMS)],
  });

  return (
    <div className="min-h-screen bg-white">
      <header>
        <h1 className="sr-only">Painters and Decorators in Watford, Hertfordshire – Brushour</h1>
      </header>
      <Navigation />
      <HeroSection />
      <ServicesSection />
      <TrustSignals />
      <AboutPreview />
      <GallerySection />
      <AreasSection />
      <ReviewsSection />
      <QuoteForm />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
